import { DateTime } from 'luxon';

import { assertNever, PaymentFrequency } from '@willow/types-iso';

export const getNextPaymentDueDate = (
  firstDueDate: Date,
  amortizationMonth: number,
  paymentFrequency: PaymentFrequency,
): Date => {
  switch (paymentFrequency) {
    case 1:
      // For anything less than 12, still return the first due date
      // First due date happens on amortization month 12
      // Second due date happens on amortization month 24
      return DateTime.fromJSDate(firstDueDate)
        .plus({ years: Math.max(Math.floor(amortizationMonth / 12) - 1, 0) })
        .toJSDate();
    case 12:
      return DateTime.fromJSDate(firstDueDate)
        .plus({ months: amortizationMonth - 1 })
        .toJSDate();
    default:
      assertNever(paymentFrequency);
  }
};
